import { useCallback } from 'react';

import { useFilters } from '../../../../hooks/useFilters';
import { SelectOption } from '../../../../models/SelectOption';
import { CorporateClientFiltersType } from './corporateClientAirAmbulanceFilters.models';

export const useCorporateClientsAirAmbulanceFilters = () => {
  const { addFilter, filters } = useFilters<CorporateClientFiltersType>();

  const onFilterChangeHandler = useCallback(
    (evt: any, filterType: CorporateClientFiltersType) => {
      switch (filterType) {
        case 'search':
          addFilter('search', evt.target.value);
          return;
        case 'type':
          addFilter('type', evt ? evt.map((x: SelectOption) => x.value) : null);
      }
    },
    [addFilter],
  );

  return { onFilterChangeHandler, filters };
};
